import React, { useState } from 'react';
import { Button } from './ui/Button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from './ui/DropdownMenu';
import { Phone, Menu, ChevronDown, X } from 'lucide-react';
export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const serviceItems = ['Bistro Lights', 'Architectural Lights', 'Landscape Lights', 'Hardscape Lights', 'Sport Court Lights', 'Backyard Lights', 'Security Lights'];
  const serviceAreas = ['Chandler', 'Gilbert', 'Queen Creek', 'Mesa', 'Phoenix', 'Paradise Valley', 'Scottsdale', 'Fountain Hills', 'San Tan Valley', 'Tempe'];
  return <header className="sticky top-0 z-50 w-full bg-[var(--brand-black)] border-b border-white/10 backdrop-blur-sm" data-id="element-71">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-72">
        <div className="flex items-center justify-between h-20" data-id="element-73">
          {/* Logo */}
          <div className="flex items-center gap-3" data-id="element-74">
            <img src="https://cdn.magicpatterns.com/uploads/f8cy29DHmDei39Mx1pqc62/Love_Outdoor_Light_Logo_New.png" alt="Love Outdoor Lighting" className="h-12 w-auto object-contain sm:h-14" data-id="element-75" />
            <span className="text-white font-bold text-base sm:text-lg uppercase tracking-wider leading-tight" data-id="element-76">
              Love Outdoor
              <br data-id="element-77" />
              Lighting
            </span>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8" data-id="element-78">
            <a href="#" className="text-white hover:text-[var(--brand-gold)] transition-colors font-medium" data-id="element-79">
              Home
            </a>

            <DropdownMenu data-id="element-80">
              <DropdownMenuTrigger className="flex items-center gap-1 text-white hover:text-[var(--brand-gold)] transition-colors font-medium" data-id="element-81">
                Services <ChevronDown className="w-4 h-4" data-id="element-82" />
              </DropdownMenuTrigger>
              <DropdownMenuContent className="bg-white" data-id="element-83">
                {serviceItems.map(service => <DropdownMenuItem key={service} className="cursor-pointer" data-id="element-84">
                    {service}
                  </DropdownMenuItem>)}
              </DropdownMenuContent>
            </DropdownMenu>

            <a href="#" className="text-white hover:text-[var(--brand-gold)] transition-colors font-medium" data-id="element-85">
              Projects
            </a>

            <DropdownMenu data-id="element-86">
              <DropdownMenuTrigger className="flex items-center gap-1 text-white hover:text-[var(--brand-gold)] transition-colors font-medium" data-id="element-87">
                Service Areas <ChevronDown className="w-4 h-4" data-id="element-88" />
              </DropdownMenuTrigger>
              <DropdownMenuContent className="bg-white" data-id="element-89">
                {serviceAreas.map(area => <DropdownMenuItem key={area} className="cursor-pointer" data-id="element-90">
                    {area}
                  </DropdownMenuItem>)}
              </DropdownMenuContent>
            </DropdownMenu>

            <a href="#" className="text-white hover:text-[var(--brand-gold)] transition-colors font-medium" data-id="element-91">
              Blog
            </a>

            <a href="#" className="text-white hover:text-[var(--brand-gold)] transition-colors font-medium" data-id="element-92">
              Contact
            </a>
          </nav>

          {/* Right Side: CTA + Phone */}
          <div className="hidden lg:flex items-center gap-4" data-id="element-93">
            <a href="tel:480-270-2014" className="flex items-center gap-2 text-white hover:text-[var(--brand-gold)] transition-colors" data-id="element-94">
              <Phone className="w-5 h-5" data-id="element-95" />
              <span className="font-medium" data-id="element-96">480-270-2014</span>
            </a>
            <Button className="bg-[var(--brand-green)] hover:bg-green-700 text-white font-medium" data-id="element-97">
              Get a Free Quote
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button className="lg:hidden flex items-center justify-center w-10 h-10 text-white" onClick={() => setMobileMenuOpen(true)} aria-label="Open menu" data-id="element-98">
            <Menu className="w-6 h-6" data-id="element-99" />
          </button>
        </div>
      </div>

      {/* Mobile Menu - Full Screen Overlay */}
      <div className={`fixed inset-0 z-[100] bg-[#0A0A0A] transition-transform duration-300 ease-in-out ${mobileMenuOpen ? 'translate-x-0' : 'translate-x-full'}`} style={{
      height: '100vh',
      width: '100vw',
      top: 0,
      left: 0
    }} data-id="element-100">
        <div className="flex flex-col" style={{
        height: '100vh'
      }} data-id="element-101">
          {/* Close button + header */}
          <div className="flex items-center justify-between p-5 border-b border-white/20" data-id="element-102">
            <h2 className="text-white text-xl font-bold" data-id="element-103">Menu</h2>
            <button onClick={() => setMobileMenuOpen(false)} className="text-white hover:text-[var(--brand-gold)] transition-colors" aria-label="Close menu" data-id="element-104">
              <X className="w-6 h-6" data-id="element-105" />
            </button>
          </div>

          {/* Scrollable nav content */}
          <nav className="flex-1 overflow-y-auto p-5" data-id="element-106">
            <div className="flex flex-col gap-4" data-id="element-107">
              <a href="#" className="text-white text-lg font-medium hover:text-[var(--brand-gold)] transition-colors py-1" onClick={() => setMobileMenuOpen(false)} data-id="element-108">
                Home
              </a>

              <div className="flex flex-col gap-1" data-id="element-109">
                <span className="text-lg font-semibold text-[var(--brand-gold)] py-1" data-id="element-110">
                  Services
                </span>
                <div className="flex flex-col pl-4" data-id="element-111">
                  {serviceItems.map(service => <a key={service} href="#" className="text-gray-300 hover:text-white transition-colors py-2 text-base" onClick={() => setMobileMenuOpen(false)} data-id="element-112">
                      {service}
                    </a>)}
                </div>
              </div>

              <a href="#" className="text-white text-lg font-medium hover:text-[var(--brand-gold)] transition-colors py-1" onClick={() => setMobileMenuOpen(false)} data-id="element-113">
                Projects
              </a>

              <div className="flex flex-col gap-1" data-id="element-114">
                <span className="text-lg font-semibold text-[var(--brand-gold)] py-1" data-id="element-115">
                  Service Areas
                </span>
                <div className="flex flex-col pl-4" data-id="element-116">
                  {serviceAreas.map(area => <a key={area} href="#" className="text-gray-300 hover:text-white transition-colors py-2 text-base" onClick={() => setMobileMenuOpen(false)} data-id="element-117">
                      {area}
                    </a>)}
                </div>
              </div>

              <a href="#" className="text-white text-lg font-medium hover:text-[var(--brand-gold)] transition-colors py-1" onClick={() => setMobileMenuOpen(false)} data-id="element-118">
                Blog
              </a>

              <a href="#" className="text-white text-lg font-medium hover:text-[var(--brand-gold)] transition-colors py-1" onClick={() => setMobileMenuOpen(false)} data-id="element-119">
                Contact
              </a>
            </div>
          </nav>

          {/* Fixed bottom CTA */}
          <div className="p-5 border-t border-white/20" data-id="element-120">
            <a href="tel:480-270-2014" className="flex items-center gap-3 text-white py-2 mb-3" data-id="element-121">
              <Phone className="w-5 h-5 text-[var(--brand-gold)]" data-id="element-122" />
              <span className="font-semibold text-lg" data-id="element-123">480-270-2014</span>
            </a>
            <Button className="w-full bg-[var(--brand-green)] hover:bg-green-700 text-white font-semibold text-base py-3 h-auto" data-id="element-124">
              Get a Free Quote
            </Button>
          </div>
        </div>
      </div>
    </header>;
}